import React, { useState } from 'react';
import './HelpIcon.css';

const HelpIcon = ({ helptext }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  // Only render if helptext exists and is not empty
  if (!helptext || helptext.trim() === '') {
    return null;
  }

  return (
    <span
      className="help-icon-container"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span className="help-icon">?</span>
      {showTooltip && (
        <span className="help-tooltip">
          {helptext}
        </span>
      )}
    </span>
  );
};

export default HelpIcon;
